import { render, staticRenderFns } from "./NotesEditor.vue?vue&type=template&id=7d7b18cd&scoped=true"
import script from "./NotesEditor.vue?vue&type=script&lang=js"
export * from "./NotesEditor.vue?vue&type=script&lang=js"
import style0 from "./NotesEditor.vue?vue&type=style&index=0&id=7d7b18cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b18cd",
  null
  
)

export default component.exports